import type { SVGProps } from "react";

export function NotificationBell(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={props.color ?? "black"}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V15.9997C21 15.5694 20.7244 15.1875 20.316 15.052C18.931 14.589 18 13.298 18 11.838V9C18 5.692 15.309 3 12 3C8.691 3 6 5.692 6 9V11.838C6 13.298 5.069 14.589 3.684 15.052C3.27563 15.1875 3 15.5694 3 15.9997V17ZM8 11.838C8 13.486 7.255 14.998 6.035 16H17.965C16.745 14.998 16 13.486 16 11.838V9C16 6.795 14.206 5 12 5C9.794 5 8 6.795 8 9V11.838Z"
            />
            <path d="M11.9997 21.0001C10.5237 21.0001 9.2477 20.1901 8.5547 19.0001H15.4457C14.7517 20.1901 13.4767 21.0001 11.9997 21.0001Z" />
        </svg>
    );
}
